import { render, staticRenderFns } from "./vendor-list.vue?vue&type=template&id=5db88e6c&scoped=true&"
import script from "./vendor-list.vue?vue&type=script&lang=js&"
export * from "./vendor-list.vue?vue&type=script&lang=js&"
import style0 from "./vendor-list.vue?vue&type=style&index=0&id=5db88e6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db88e6c",
  null
  
)

export default component.exports